import n8nApi from './n8n.api';

export const TermValidationService = {
  async validate(file) {
    const formData = new FormData();
    formData.append('file', file);

    const response = await n8nApi.post('/validar-termo', formData);
    return response.data;
  },
};
